/**
 * `tag:` prefix parsing for the worklist report-search inputs (Phase 7).
 *
 * The API keeps keyword and tag as two explicit params (`&reportKeyword=` and
 * `&tag=`); the `tag:` prefix is a pure input-affordance parsed CLIENT-side:
 *
 *   `tag:CHF`                            -> { tag: 'CHF' }
 *   `tag:"congestive heart failure"`     -> { tag: 'congestive heart failure' }
 *   `effusion tag:chf`                   -> { keyword: 'effusion', tag: 'chf' }
 *
 * When both parts are present the backend ANDs them. Normalization
 * (lowercasing) happens server-side — the tag is sent as typed.
 */
// First `tag:` token: quoted ("multi word") or bare (single token). Only the
// first occurrence is treated as the tag filter; any later ones stay in the
// keyword text verbatim.
const TAG_TOKEN_RE = /(^|\s)tag:(?:"([^"]*)"|(\S+))/i;
/** Parse a raw search-box value into its keyword and tag parts. */
export function parseTagSearchInput(raw) {
    const match = TAG_TOKEN_RE.exec(raw);
    if (!match) {
        const keyword = raw.trim();
        return keyword ? { keyword } : {};
    }
    // Quoted capture wins; a bare capture gets stray quote chars stripped so a
    // mid-typing unclosed quote (`tag:"conge`) doesn't ship a `"` to the API.
    const tagValue = (match[2] ?? match[3].replace(/"/g, '')).trim();
    const keyword = (raw.slice(0, match.index) + ' ' + raw.slice(match.index + match[0].length))
        .replace(/\s+/g, ' ')
        .trim();
    const result = {};
    if (keyword)
        result.keyword = keyword;
    if (tagValue)
        result.tag = tagValue;
    return result;
}
/** Canonical input text for a keyword+tag pair (inverse of parse, for
 * seeding the input from URL/filter state). Multi-word tags are quoted. */
export function formatTagSearchInput(parsed) {
    const parts = [];
    if (parsed.tag) {
        parts.push(/\s/.test(parsed.tag) ? `tag:"${parsed.tag}"` : `tag:${parsed.tag}`);
    }
    if (parsed.keyword)
        parts.push(parsed.keyword);
    return parts.join(' ');
}
